import { AppAction, BaseAsyncReducerState } from "../../types";
import { TAKE_SURVEY } from "../../actionTypes/actionsTypes";

export interface AmpSurveyState extends BaseAsyncReducerState {
    updated: boolean | null
}

const initialState: AmpSurveyState = {
    updated: null,
    loading: false,
    error: false
}

export function getSurveyReducer(state = initialState, action: AppAction){
        // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case TAKE_SURVEY.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
            }
        case TAKE_SURVEY.SUCCESS:
            return {
                ...state,
                password: { ...payload },
                loading: false,
                error: false,

            }
        case TAKE_SURVEY.ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                data: payload,
            };
        case TAKE_SURVEY.RESET:
            return {
                ...initialState,
            };
        default:
            return state
    }
}